import { render, staticRenderFns } from "./NsHeaderLegalLinks.vue?vue&type=template&id=abe7f0a0&scoped=true&"
import script from "./NsHeaderLegalLinks.vue?vue&type=script&lang=js&"
export * from "./NsHeaderLegalLinks.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderLegalLinks.vue?vue&type=style&index=0&id=abe7f0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe7f0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe7f0a0')) {
      api.createRecord('abe7f0a0', component.options)
    } else {
      api.reload('abe7f0a0', component.options)
    }
    module.hot.accept("./NsHeaderLegalLinks.vue?vue&type=template&id=abe7f0a0&scoped=true&", function () {
      api.rerender('abe7f0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsHeaderLegalLinks.vue"
export default component.exports